export default __webpack_public_path__ + "static/media/CAShield.3aaf3bec.png";